import { InjectionToken } from '@angular/core';

export const HERO_DEFAULT_LOCATION = new InjectionToken<string>('HERO default location');
